export interface WebUIElements {
  [key: string]: any;
}

export function createWebUIElements(): WebUIElements {
  return {
  themeSwitcher: document.querySelector("#themeSwitcher"),
  languageSelect: document.querySelector("#languageSelect"),
  sidebar: document.querySelector("#sidebar"),
  sidebarResizeHandle: document.querySelector("#sidebarResizeHandle"),
  sidebarResizeShield: document.querySelector("#sidebarResizeShield"),
  authSourceGroup: document.querySelector("#authSourceGroup"),
  authSourceDetail: document.querySelector("#authSourceDetail"),
  apiSourceSettingsButton: document.querySelector("#generationProviderSettingsButton"),
  modelFamilyOptions: document.querySelector("#modelFamilyOptions"),
  concreteModelSelect: document.querySelector("#concreteModelSelect"),
  concreteModelOptions: document.querySelector("#concreteModelOptions"),
  generationProviderSelect: document.querySelector("#generationProviderSelect"),
  generationProviderSettingsButton: document.querySelector("#generationProviderSettingsButton"),
  githubLink: document.querySelector("#githubLink"),
  apiStatus: document.querySelector("#apiStatus"),
  versionInfo: document.querySelector("#versionInfo"),
  versionLabel: document.querySelector("#versionLabel"),
  versionUpdateBadge: document.querySelector("#versionUpdateBadge"),
  versionModal: document.querySelector("#versionModal"),
  versionModalClose: document.querySelector("#versionModalClose"),
  versionModalStatus: document.querySelector("#versionModalStatus"),
  versionCurrent: document.querySelector("#versionCurrent"),
  versionLatest: document.querySelector("#versionLatest"),
  versionSource: document.querySelector("#versionSource"),
  versionOnboardingNotice: document.querySelector("#versionOnboardingNotice"),
  versionOnboardingBody: document.querySelector("#versionOnboardingBody"),
  versionReleaseLink: document.querySelector("#versionReleaseLink"),
  versionStandardDownloadLink: document.querySelector("#versionStandardDownloadLink"),
  versionUpdateButton: document.querySelector("#versionUpdateButton"),
  versionContinuePortableButton: document.querySelector("#versionContinuePortableButton"),
  versionDismissOnboardingButton: document.querySelector("#versionDismissOnboardingButton"),
  apiDirectSettingsButton: document.querySelector("#apiDirectSettingsButton"),
  queueButton: document.querySelector("#queueButton"),
  queueStatusText: document.querySelector("#queueStatusText"),
  taskNotificationButton: document.querySelector("#taskNotificationButton"),
  taskNotificationBadge: document.querySelector("#taskNotificationBadge"),
  taskNotificationCenter: document.querySelector("#taskNotificationCenter"),
  taskNotificationUnreadSummary: document.querySelector("#taskNotificationUnreadSummary"),
  taskNotificationClearButton: document.querySelector("#taskNotificationClearButton"),
  taskNotificationList: document.querySelector("#taskNotificationList"),
  taskNotificationToastRegion: document.querySelector("#taskNotificationToastRegion"),
  taskNotificationInApp: document.querySelector("#taskNotificationInApp"),
  taskNotificationSystem: document.querySelector("#taskNotificationSystem"),
  taskHistoryShell: document.querySelector(".task-history-shell"),
  sidebarContent: document.querySelector(".sidebar-content"),
  taskActiveList: document.querySelector("#taskActiveList"),
  taskLatestButton: document.querySelector("#taskLatestButton"),
  taskLatestBadge: document.querySelector("#taskLatestBadge"),
  taskList: document.querySelector("#taskList"),
  taskSearch: document.querySelector("#taskSearch"),
  taskSearchClearButton: document.querySelector("#taskSearchClearButton"),
  taskFilterButton: document.querySelector("#taskFilterButton"),
  taskFilterPopover: document.querySelector("#taskFilterPopover"),
  taskFilterClearButton: document.querySelector("#taskFilterClearButton"),
  taskFilterActiveCount: document.querySelector("#taskFilterActiveCount"),
  taskStatusFilter: document.querySelector("#taskStatusFilter"),
  taskRatioFilter: document.querySelector("#taskRatioFilter"),
  taskOrientationFilter: document.querySelector("#taskOrientationFilter"),
  taskPromptFidelityFilter: document.querySelector("#taskPromptFidelityFilter"),
  taskResolutionFilter: document.querySelector("#taskResolutionFilter"),
  taskHistoryTopAnchors: document.querySelector("#taskHistoryTopAnchors"),
  taskHistoryBottomAnchors: document.querySelector("#taskHistoryBottomAnchors"),
  taskHistoryLibrarySlot: document.querySelector("#taskHistoryLibrarySlot"),
  archiveButton: document.querySelector("#archiveButton"),
  batchCancelTasksButton: document.querySelector("#batchCancelTasksButton"),
  batchManageButton: document.querySelector("#batchManageButton"),
  batchToolbar: document.querySelector("#batchToolbar"),
  batchSelectedCount: document.querySelector("#batchSelectedCount"),
  batchSelectGroupButton: document.querySelector("#batchSelectGroupButton"),
  batchArchiveButton: document.querySelector("#batchArchiveButton"),
  batchCancelSelectedButton: document.querySelector("#batchCancelSelectedButton"),
  batchDeleteButton: document.querySelector("#batchDeleteButton"),
  batchCancelButton: document.querySelector("#batchCancelButton"),
  archiveModal: document.querySelector("#archiveModal"),
  archiveModalClose: document.querySelector("#archiveModalClose"),
  archiveList: document.querySelector("#archiveList"),
  archiveCount: document.querySelector("#archiveCount"),
  systemSettingsModal: document.querySelector("#systemSettingsModal"),
  systemSettingsModalClose: document.querySelector("#systemSettingsModalClose"),
  systemSettingsTabs: document.querySelector("#systemSettingsTabs"),
  systemSettingsApiTab: document.querySelector("#systemSettingsApiTab"),
  systemSettingsNetworkTab: document.querySelector("#systemSettingsNetworkTab"),
  systemSettingsLanguageTab: document.querySelector("#systemSettingsLanguageTab"),
  systemSettingsStorageTab: document.querySelector("#systemSettingsStorageTab"),
  systemSettingsApiPanel: document.querySelector("#systemSettingsApiPanel"),
  systemSettingsNetworkPanel: document.querySelector("#systemSettingsNetworkPanel"),
  systemSettingsLanguagePanel: document.querySelector("#systemSettingsLanguagePanel"),
  systemSettingsStoragePanel: document.querySelector("#systemSettingsStoragePanel"),
  networkEgressMode: document.querySelector("#networkEgressMode"),
  networkEgressCustomProxyField: document.querySelector("#networkEgressCustomProxyField"),
  networkEgressCustomProxy: document.querySelector("#networkEgressCustomProxy"),
  networkEgressCurrentRoute: document.querySelector("#networkEgressCurrentRoute"),
  networkEgressStatus: document.querySelector("#networkEgressStatus"),
  testNetworkEgressButton: document.querySelector("#testNetworkEgressButton"),
  saveNetworkEgressButton: document.querySelector("#saveNetworkEgressButton"),
  languageSettingsStatus: document.querySelector("#languageSettingsStatus"),
  settingsStatus: document.querySelector("#settingsStatus"),
  settingsInputRoot: document.querySelector("#settingsInputRoot"),
  settingsOutputRoot: document.querySelector("#settingsOutputRoot"),
  settingsGalleryRoot: document.querySelector("#settingsGalleryRoot"),
  settingsSourceDataRoot: document.querySelector("#settingsSourceDataRoot"),
  saveSettingsButton: document.querySelector("#saveSettingsButton"),
  apiSettingsStatus: document.querySelector("#apiSettingsStatus"),
  apiSettingsActions: document.querySelector("#apiSettingsActions"),
  apiProviderQuick: document.querySelector("#apiProviderQuick"),
  apiProvider: document.querySelector("#apiProvider"),
  apiProviderSection: document.querySelector("#apiProviderSection"),
  apiProviderCount: document.querySelector("#apiProviderCount"),
  apiProviderSearch: document.querySelector("#apiProviderSearch"),
  apiProviderList: document.querySelector("#apiProviderList"),
  apiProviderDetail: document.querySelector("#apiProviderDetail"),
  apiProviderDetailBaseUrl: document.querySelector("#apiProviderDetailBaseUrl"),
  apiProviderDetailKey: document.querySelector("#apiProviderDetailKey"),
  apiProviderDetailMode: document.querySelector("#apiProviderDetailMode"),
  apiProviderDetailConcurrency: document.querySelector("#apiProviderDetailConcurrency"),
  apiProviderEditor: document.querySelector("#apiProviderEditor"),
  apiProviderEditorTitle: document.querySelector("#apiProviderEditorTitle"),
  apiProviderName: document.querySelector("#apiProviderName"),
  apiProviderIconEmoji: document.querySelector("#apiProviderIconEmoji"),
  editApiProviderButton: document.querySelector("#editApiProviderButton"),
  copyApiProviderButton: document.querySelector("#copyApiProviderButton"),
  addApiProviderButton: document.querySelector("#addApiProviderButton"),
  sortApiProvidersButton: document.querySelector("#sortApiProvidersButton"),
  deleteApiProviderButton: document.querySelector("#deleteApiProviderButton"),
  cancelApiProviderEditButton: document.querySelector("#cancelApiProviderEditButton"),
  saveApiProviderEditButton: document.querySelector("#saveApiProviderEditButton"),
  apiBaseUrl: document.querySelector("#apiBaseUrl"),
  apiRequestEndpointPreview: document.querySelector("#apiRequestEndpointPreview"),
  apiKey: document.querySelector("#apiKey"),
  apiKeyRevealButton: document.querySelector("#apiKeyRevealButton"),
  apiImagesConcurrency: document.querySelector("#apiImagesConcurrency"),
  apiProviderBindings: document.querySelector("#apiProviderBindings"),
  addProviderBindingButton: document.querySelector("#addProviderBindingButton"),
  newTaskButton: document.querySelector("#newTaskButton"),
  imageInput: document.querySelector("#imageInput"),
  referenceFileSelection: document.querySelector("#referenceFileSelection"),
  imageEditorModal: document.querySelector("#imageEditorModal"),
  imageEditorClose: document.querySelector("#imageEditorClose"),
  imageEditorSubtitle: document.querySelector("#imageEditorSubtitle"),
  imageEditorCanvas: document.querySelector("#imageEditorCanvas"),
  imageEditorCanvasWrap: document.querySelector("#imageEditorCanvasWrap"),
  imageEditorKonvaMount: document.querySelector("#imageEditorKonvaMount"),
  imageEditorCropBox: document.querySelector("#imageEditorCropBox"),
  imageEditorToolSelect: document.querySelector("#imageEditorToolSelect"),
  imageEditorToolBrush: document.querySelector("#imageEditorToolBrush"),
  imageEditorToolArrow: document.querySelector("#imageEditorToolArrow"),
  imageEditorToolCrop: document.querySelector("#imageEditorToolCrop"),
  imageEditorToolFill: document.querySelector("#imageEditorToolFill"),
  imageEditorToolEraser: document.querySelector("#imageEditorToolEraser"),
  imageEditorInsertList: document.querySelector("#imageEditorInsertList"),
  imageEditorLayerList: document.querySelector("#imageEditorLayerList"),
  imageEditorLayerUp: document.querySelector("#imageEditorLayerUp"),
  imageEditorLayerDown: document.querySelector("#imageEditorLayerDown"),
  imageEditorLayerDelete: document.querySelector("#imageEditorLayerDelete"),
  imageEditorColor: document.querySelector("#imageEditorColor"),
  imageEditorStroke: document.querySelector("#imageEditorStroke"),
  imageEditorStrokeValue: document.querySelector("#imageEditorStrokeValue"),
  imageEditorUndo: document.querySelector("#imageEditorUndo"),
  imageEditorRedo: document.querySelector("#imageEditorRedo"),
  imageEditorReset: document.querySelector("#imageEditorReset"),
  imageEditorSave: document.querySelector("#imageEditorSave"),
  imageEditorCancel: document.querySelector("#imageEditorCancel"),
  imageEditorStatus: document.querySelector("#imageEditorStatus"),
  recentAssetDock: document.querySelector("#recentAssetDock"),
  recentAssetList: document.querySelector("#recentAssetList"),
  referenceCollector: document.querySelector("#referenceCollector"),
  imageStrip: document.querySelector("#imageStrip"),
  imageThumbList: document.querySelector("#imageThumbList"),
  imageThumbItems: document.querySelector("#imageThumbItems"),
  imageUploaderGrid: document.querySelector(".image-uploader-grid"),
  imageUploadSource: document.querySelector("#imageUploadSource"),
  quickGalleryDock: document.querySelector("#quickGalleryDock"),
  quickGalleryPreview: document.querySelector("#quickGalleryPreview"),
  quickGalleryList: document.querySelector("#quickGalleryList"),
  quickGalleryRail: document.querySelector("#quickGalleryRail"),
  galleryManagePanel: document.querySelector("#galleryManagePanel"),
  galleryManageButton: document.querySelector("#galleryManageButton"),
  galleryDrawer: document.querySelector("#galleryDrawer"),
  galleryDrawerClose: document.querySelector("#galleryDrawerClose"),
  galleryDrawerBackdrop: document.querySelector("#galleryDrawerBackdrop"),
  galleryDrawerSubtitle: document.querySelector("#galleryDrawerSubtitle"),
  galleryDrawerCategoryTabs: document.querySelector("#galleryDrawerCategoryTabs"),
  galleryCategoryManagePanel: document.querySelector("#galleryCategoryManagePanel"),
  galleryCategoryManageToggle: document.querySelector("#galleryCategoryManageToggle"),
  galleryCategoryList: document.querySelector("#galleryCategoryList"),
  newGalleryCategoryName: document.querySelector("#newGalleryCategoryName"),
  newGalleryCategoryPromptRole: document.querySelector("#newGalleryCategoryPromptRole"),
  addGalleryCategoryButton: document.querySelector("#addGalleryCategoryButton"),
  galleryGrid: document.querySelector("#galleryGrid"),
  addToGalleryModal: document.querySelector("#addToGalleryModal"),
  addToGalleryClose: document.querySelector("#addToGalleryClose"),
  addToGalleryPreview: document.querySelector("#addToGalleryPreview"),
  galleryNameInput: document.querySelector("#galleryNameInput"),
  galleryCategoryInput: document.querySelector("#galleryCategoryInput"),
  galleryPromptNoteInput: document.querySelector("#galleryPromptNoteInput"),
  saveToGalleryButton: document.querySelector("#saveToGalleryButton"),
  clearImagesButton: document.querySelector("#clearImagesButton"),
  pasteClipboardButton: document.querySelector("#pasteClipboardButton"),
  prompt: document.querySelector("#prompt"),
  promptEditor: document.querySelector("#promptEditor"),
  promptTemplateButton: document.querySelector("#promptTemplateButton"),
  promptTemplateRecentDock: document.querySelector("#promptTemplateRecentDock"),
  promptTemplateDrawer: document.querySelector("#promptTemplateDrawer"),
  promptTemplateDrawerClose: document.querySelector("#promptTemplateDrawerClose"),
  promptTemplateDrawerBackdrop: document.querySelector("#promptTemplateDrawerBackdrop"),
  promptTemplateSummary: document.querySelector("#promptTemplateSummary"),
  promptTemplateSearch: document.querySelector("#promptTemplateSearch"),
  promptTemplateSearchClearButton: document.querySelector("#promptTemplateSearchClearButton"),
  promptTemplateCreateButton: document.querySelector("#promptTemplateCreateButton"),
  promptTemplateImportButton: document.querySelector("#promptTemplateImportButton"),
  promptTemplateImportInput: document.querySelector("#promptTemplateImportInput"),
  promptTemplateExportButton: document.querySelector("#promptTemplateExportButton"),
  promptTemplateCategoryList: document.querySelector("#promptTemplateCategoryList"),
  promptTemplateCategoryManageButton: document.querySelector("#promptTemplateCategoryManageButton"),
  promptTemplateCategoryPanel: document.querySelector("#promptTemplateCategoryPanel"),
  promptTemplateList: document.querySelector("#promptTemplateList"),
  promptTemplateDetail: document.querySelector("#promptTemplateDetail"),
  promptTemplateForm: document.querySelector("#promptTemplateForm"),
  mentionSuggest: document.querySelector("#mentionSuggest"),
  colorSuggest: document.querySelector("#colorSuggest"),
  charCount: document.querySelector("#charCount"),
  clearPromptButton: document.querySelector("#clearPromptButton"),
  promptFindButton: document.querySelector("#promptFindButton"),
  promptFindPanel: document.querySelector("#promptFindPanel"),
  promptFindInput: document.querySelector("#promptFindInput"),
  promptReplaceInput: document.querySelector("#promptReplaceInput"),
  promptFindCount: document.querySelector("#promptFindCount"),
  promptFindStatus: document.querySelector("#promptFindStatus"),
  promptFindClose: document.querySelector("#promptFindClose"),
  modeSettingsSlot: document.querySelector("#modeSettingsSlot"),
  outputSettingsHeader: document.querySelector("#outputSettingsHeader"),
  outputSettingsLockButton: document.querySelector("#outputSettingsLockButton"),
  outputSettingsLockedSummary: document.querySelector("#outputSettingsLockedSummary"),
  outputSettingsSummaryContent: document.querySelector("#outputSettingsSummaryContent"),
  outputSettingsTaskAction: document.querySelector("#outputSettingsTaskAction"),
  adoptTaskOutputSettingsButton: document.querySelector("#adoptTaskOutputSettingsButton"),
  outputSettingsStage: document.querySelector("#outputSettingsStage"),
  modelParameterGrid: document.querySelector("#modelParameterGrid"),
  taskParameterInspector: document.querySelector("#taskParameterInspector"),
  taskParameterInspectorHeader: document.querySelector("#taskParameterInspectorHeader"),
  taskParameterInspectorGrid: document.querySelector("#taskParameterInspectorGrid"),
  taskParameterInspectorUnknown: document.querySelector("#taskParameterInspectorUnknown"),
  modeSpecificSettings: document.querySelector("#modeSpecificSettings"),
  mainModelField: document.querySelector("#mainModelField"),
  mainModelCombobox: document.querySelector("#mainModelCombobox"),
  mainModel: document.querySelector("#mainModel"),
  mainModelToggle: document.querySelector("#mainModelToggle"),
  mainModelOptions: document.querySelector("#mainModelOptions"),
  webSearchField: document.querySelector("#webSearchField"),
  webSearch: document.querySelector("#webSearch"),
  promptFidelityField: document.querySelector("#promptFidelityField"),
  promptFidelity: document.querySelector("#promptFidelity"),
  apiDirectSettingsNotice: document.querySelector("#apiDirectSettingsNotice"),
  settingsGrid: document.querySelector("#settingsGrid"),
  model: document.querySelector("#model"),
  size: document.querySelector("#size"),
  sizeModeGroup: document.querySelector("#sizeModeGroup"),
  customSizeToggle: document.querySelector("#customSizeToggle"),
  nInput: document.querySelector("#nInput"),
  nValue: document.querySelector("#nValue"),
  resolution: document.querySelector("#resolution"),
  ratio: document.querySelector("#ratio"),
  orientation: document.querySelector("#orientation"),
  pixelPreview: document.querySelector("#pixelPreview"),
  customSize: document.querySelector("#customSize"),
  customSizeHint: document.querySelector("#customSizeHint"),
  customWidth: document.querySelector("#customWidth"),
  customHeight: document.querySelector("#customHeight"),
  customRatioField: document.querySelector(".custom-ratio-field"),
  customRatioWidth: document.querySelector("#customRatioWidth"),
  customRatioHeight: document.querySelector("#customRatioHeight"),
  customRatioFromImageButton: document.querySelector("#customRatioFromImageButton"),
  swapCustomSizeButton: document.querySelector("#swapCustomSizeButton"),
  quality: document.querySelector("#quality"),
  outputFormat: document.querySelector("#outputFormat"),
  outputFormatField: document.querySelector("#outputFormatField"),
  outputFormatGroup: document.querySelector("#outputFormatGroup"),
  moderation: document.querySelector("#moderation"),
  compressionPopover: document.querySelector("#compressionPopover"),
  compressionField: document.querySelector("#compressionField"),
  compression: document.querySelector("#compression"),
  compressionValue: document.querySelector("#compressionValue"),
  runButton: document.querySelector("#runButton"),
  statusText: document.querySelector("#statusText"),
  previewGrid: document.querySelector("#previewGrid"),
  downloadAllButton: document.querySelector("#downloadAllButton"),
  previewSelectionActions: document.querySelector("#previewSelectionActions"),
  previewSelectionCount: document.querySelector("#previewSelectionCount"),
  downloadSelectedButton: document.querySelector("#downloadSelectedButton"),
  deleteUnselectedOutputsButton: document.querySelector("#deleteUnselectedOutputsButton"),
  refreshButton: document.querySelector("#refreshButton"),
  copyJsonButton: document.querySelector("#copyJsonButton"),
  requestJson: document.querySelector("#requestJson"),
  controlsCol: document.querySelector(".controls-col"),
  previewCol: document.querySelector(".preview-col"),
  previewPanel: document.querySelector(".preview-panel"),
  };
}
